import React from 'react';
import { ArrowRight } from 'lucide-react';
import { GOLD } from '../../constants/booking';

export default function CheckoutFooter({ showCheckout, error, onBookNow, pricing }) {
  if (!showCheckout) {
    return (
      <div
        style={{
          backgroundColor: '#111111',
          border: '1px dashed rgba(201, 168, 76, 0.3)',
          borderRadius: '1rem',
          padding: '1.5rem',
          textAlign: 'center',
          marginTop: 'auto',
          paddingTop: '1.5rem',
        }}
      >
        <p style={{ color: '#F5F0E8', fontSize: '0.875rem', margin: 0 }}>
          Select a date and time to enable booking.
        </p>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 'auto', paddingTop: '1.5rem' }}>
      {error && (
        <div
          style={{
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.4)',
            borderRadius: '0.75rem',
            padding: '1rem',
            marginBottom: '1rem',
            color: '#fca5a5',
          }}
        >
          {error}
        </div>
      )}

      <button
        type="button"
        onClick={onBookNow}
        style={{
          width: '100%',
          backgroundColor: GOLD,
          color: '#000000',
          border: 'none',
          borderRadius: '1rem',
          padding: '1rem 2rem',
          fontSize: '1.125rem',
          fontWeight: '700',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
        }}
      >
        Book Now — ${pricing.total}
        <ArrowRight size={20} />
      </button>

      <p style={{ textAlign: 'center', fontSize: '0.8125rem', color: '#F5F0E8', marginTop: '0.75rem' }}>
        No account needed — you&apos;ll get a confirmation code by email to manage your booking.
      </p>
    </div>
  );
}
